import { useMemo } from "react";
import { Avatar, Divider, Grid2 as Grid, Paper, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import Map, { Marker } from "@/components/map/Map";
import DataCell from "@/components/DataCell";
import { useUserProfile } from "@/hooks";
import { Order, User, AnonymousUser, OrderStatus } from "@/types";
import { HugeiconsIcon } from "@hugeicons/react";
import { Home01Icon, RoadLocation01Icon, UserIcon, WhatsappIcon } from "@hugeicons/core-free-icons";
import { formatPhone } from "@/utils/phones";

const ClientDetails = (order: Order) => {
  const { palette } = useTheme();
  const { getUserById } = useUserProfile();

  const authClient = useMemo(() => getUserById(order?.client as unknown as string) as User, [getUserById, order?.client]);

  const anonClient = order.client;

  const client: AnonymousUser | User = authClient ?? anonClient;

  const contactClient = () => {
    if (order.status === OrderStatus.REJECTED) {
      const message = `Hola ${client.name},%0A%0ASu pedido con número de orden ${order?.number} ha tenido un problema y no podemos procesarlo en este momento.%0A%0ALamentamos los inconvenientes causados.%0A%0AEn un momento nos contactaremos para brindarte más detalles y resolver la situación.%0A%0AGracias por su comprensión.`;
      window.open(`https://wa.me/505${client.phone}?text=${message}`);
    } else {
      const message = `Hola ${client.name},%0A%0ASu pedido con número de orden ${order?.number} está siendo procesado.%0A%0AGracias por su preferencia.`;
      window.open(`https://wa.me/505${client.phone}?text=${message}`);
    }
  };

  return (
    <>
      <Grid container spacing={2} alignContent="flex-start" height="100%">
        <Grid size={{ xs: 12, sm: 4 }}>
          <Stack spacing={2}>
            <Paper
              sx={{
                p: 2,
              }}
            >
              <Stack justifyContent={"center"} alignItems={"center"} spacing={2} paddingTop={2}>
                {(client as any)?.image ? (
                  <Avatar src={(client as any).image} alt="Foto de perfil del cliente" sx={{ width: 100, height: 100 }} />
                ) : (
                  <Avatar
                    sx={{
                      width: 100,
                      height: 100,
                      backgroundColor: palette.primary.light,
                    }}
                  >
                    <HugeiconsIcon icon={UserIcon} color={palette.primary.main} size={50} />
                  </Avatar>
                )}
                {client?.name ? (
                  <Typography variant="h4" sx={{ textAlign: "center" }}>
                    {client.name} {client?.lastname ?? ""}
                  </Typography>
                ) : null}
                <Divider />
              </Stack>
            </Paper>
            <Paper
              sx={{
                p: 2,
              }}
            >
              <Stack direction={"row"} spacing={2} alignItems={"center"}>
                <Tooltip title="Enviar mensaje" placement="top" arrow>
                  <HugeiconsIcon icon={WhatsappIcon} color={palette.primary.main} size={22} onClick={contactClient} />
                </Tooltip>
                <DataCell vertical label="Whatsapp" value={formatPhone(client?.phone)} />
              </Stack>
            </Paper>

          </Stack>
        </Grid>
        <Grid size={{ xs: 12, sm: 8 }}>
          <Paper
            sx={{
              width: "100%",
            }}
          >
            <Stack spacing={2} p={2}>
              {/* <Stack direction={"row"} spacing={2} alignItems={"center"} px={2} pt={2}>
                <HugeiconsIcon icon={Location01Icon} color={palette.primary.main} />
                <DataCell vertical label="Barrio" value={getNeighborhoodName(order.deliveryLocation?.neighborhood)} />
              </Stack> */}
              <Stack direction={"row"} spacing={2} alignItems={"center"} px={2}>
                <HugeiconsIcon icon={Home01Icon} color={palette.primary.main} />
                <DataCell vertical label="No. de Casa" value={order.deliveryLocation?.house} />
              </Stack>
              <Stack direction={"row"} spacing={2} alignItems={"center"} px={2}>
                <HugeiconsIcon icon={RoadLocation01Icon} color={palette.primary.main} />
                <DataCell vertical label="Dirección / Cómo llegar:" value={order.deliveryLocation?.address} />
              </Stack>
              <Map height={"370px"} type={"roadmap" as any}>
                <Marker {...({ lat: order.deliveryLocation?.latitude ?? "", lng: order.deliveryLocation?.longitude ?? "" } as any)} />
              </Map>
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default ClientDetails;
